import { render, staticRenderFns } from "./InsertClass.vue?vue&type=template&id=4c66a5b8&scoped=true"
import script from "./InsertClass.vue?vue&type=script&lang=js"
export * from "./InsertClass.vue?vue&type=script&lang=js"
import style0 from "./InsertClass.vue?vue&type=style&index=0&id=4c66a5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66a5b8",
  null
  
)

export default component.exports